import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const ScrollIndicator: React.FC = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [arrowPosition, setArrowPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (totalHeight <= 0) return; // Prevent division by zero
      
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
      
      // Calculate arrow position based on scroll progress
      setArrowPosition((window.scrollY / totalHeight) * 80); // 80% of the screen height
    };

    window.addEventListener('scroll', handleScroll);
    // Initial call to set initial state
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Progress Bar */}
      <div className="fixed top-0 left-0 right-0 h-1 bg-gray-200 z-50">
        <div 
          className="h-full bg-orange-500 transition-all duration-300 ease-out"
          style={{ width: `${scrollProgress}%` }}
        ></div>
      </div>

      {/* Scroll Indicator Arrow - Always visible */}
      <div 
        className="fixed right-8 z-40 transition-all duration-500 ease-in-out animate-bounce"
        style={{ top: `${arrowPosition}%` }}
      >
        <div className="bg-orange-500 text-white p-3 rounded-full shadow-lg">
          <ChevronDown className="h-6 w-6" />
        </div>
      </div>
    </>
  );
};

export default ScrollIndicator;